import React         from 'react'
import ButtonLoading from "../common/ButtonLoading"

class ActivateError extends React.Component {
  agree () {
    window.location.href = "/"
  }

  render() {
    return (
      <div className="login-container">
        <div className="text-center login-block">
          <p className="line1">問題が発生しました</p>
          <p className="line2 ">
            問題が発生したため処理を中断しました。<br />
            時間をおいてログイン画面よりログインしてください。
          </p>
          <ButtonLoading text="トップページに戻る" className="btn mfc-btn-blue medium" type="button" onClick={this.agree} />
        </div>
      </div>
    )
  }
}

export default ActivateError
